import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { SbMenuService } from '../services';
import { AppConfigQuery } from '../../core/state/app-config/app-config.query';
import { SessionQuery } from '../../core/state/session/session.query';
import { ImpersonateQuery } from '../../pages/admin/impersonate/state/impersonate.query';
import { ToastService } from '../../shared/services/toast/toast.service';

@Injectable()
export class LandingPageResolver implements Resolve<any> {
    constructor(
        private router: Router,
        private menuService: SbMenuService,
        private _appConfig: AppConfigQuery,
        private _sessionQuery: SessionQuery,
        private _impersonateQuery: ImpersonateQuery,
        private _toastService: ToastService
    ) {}
    resolve(route: ActivatedRouteSnapshot): any {
        const url =
            // if user is admin, redirect to admin page
            this._sessionQuery.isAdminUser
                ? '/admin'
                : // if user is asset manager and not impersonating another user, redirect to impersonation page
                this._sessionQuery.isAssetManager &&
                  !this._impersonateQuery.activeImpersonation
                ? '/impersonation'
                : // if user is not admin or asset manager, redirect to landing page
                  this._appConfig.appConfig.landingPageOverride || false;

        const resumeStorageKey = `${this._sessionQuery.sessionStorageKey}_sbResumeUrl`;
        let resumeUrl = sessionStorage.getItem(resumeStorageKey);
        // if there is a resume url...
        if (resumeUrl) {
            // ...decode it and remove it from storage
            resumeUrl = atob(resumeUrl);
            sessionStorage.removeItem(resumeStorageKey);
            // if the resume url is different from the normal landing page url...
            if (resumeUrl !== url) {
                // ...show a toast asking the user if they want to resume where they left off
                this._toastService
                    .show({
                        intent: 'info',
                        title: '💪Welcome back!',
                        message: 'Do you want to resume where you left off?',
                        actions: { primary: 'Yes', secondary: 'No' }
                    })
                    .$action.subscribe((action) => {
                        if (action.name === 'primary') {
                            // ...navigate to the resume url
                            this.router.navigateByUrl(this.router.parseUrl(resumeUrl));
                        }
                    });
            }
        }

        if (url) {
            this.router.navigate([url]);
            return;
        }
        try {
            this.menuService.getRoutesConfiguration().then((routes) => {
                this.router.navigate([routes.landingPage]);
            });
        } catch (error) {
            console.error(error);
            this.router.navigate(['not-found']);
        }
    }
}
